import styled from "styled-components";

export const Footer = () => {
  return <FooterContainer id="footer"></FooterContainer>;
};

const FooterContainer = styled.div`
  height: 100px;
`;
